import 'moment/locale/fi';
import moment from 'moment';
import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import { requestDestinationList } from '../actions/destination';
import { setSubNavbar } from '../actions/navbar';
import { requestChangeOrder } from '../actions/order';
import Input from '../components/forms/Input';
import Select from '../components/forms/Select';
import TextArea from '../components/forms/TextArea';
import ServiceSiteList from '../components/servicesite/ServiceSiteList';

class ChangeOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      destinationId: undefined,
    };
  }

  componentDidMount() {
    const { destinationList } = this.props;
    const { translate, setSubNavbar, requestDestinationList } = this.props;

    setSubNavbar({
      title: [
        translate('navigation.change_order'),
      ],
    });

    if (!destinationList) {
      requestDestinationList();
    }
  }

  onDestinationSelected = (evt) => {
    const { target: { value } = {} } = evt;

    this.setState({
      destinationId: value || undefined,
    });
  };

  onSubmit = (evt) => {
    const { requestChangeOrder, translate } = this.props;

    evt.preventDefault();

    const data = {
      serviceSiteId: [],
    };

    const formData = new FormData(evt.target);
    for (const [key, value] of formData.entries()) {
      if (Array.isArray(data[key])) {
        data[key].push(value);
      } else {
        data[key] = value;
      }
      if (key.endsWith('Date') && value) {
        data[key] = moment(value, translate('change_order_properties.date-format'))
          .format('YYYY-MM-DD');
      }
    }

    requestChangeOrder(data, this.onChangeOrderError, this.onChangeOrderSuccess);
  };

  onChangeOrderSuccess = () => {
    const { translate, history: { push } } = this.props;
    const { requestDestinationList } = this.props;

    toast(translate('change_order_request.success'));

    requestDestinationList();
    push('/');
  }

  onChangeOrderError = () => {
    const { translate } = this.props;

    toast.error(translate('change_order_request.error'));
  };

  formatDate = (date) => {
    // NB It's unclear why format 'L' with required locale doesn't work.
    const { translate } = this.props;
    return moment(date)
      .format(translate('change_order_properties.date-format'));
  };

  parseDate = (str) => {
    // NB It's unclear why format 'L' with required locale doesn't work.
    const { translate } = this.props;
    const m = moment(str, translate('change_order_properties.date-format'));
    if (m.isValid()) {
      return m.toDate();
    }
    return undefined;
  };

  renderChangeDetails() {
    const { translate, currentLanguage } = this.props;

    return (
      <div className="normal-color">
        <h2>{translate('change_order')}</h2>
        <div className="row">
          <div className="col-sm-4">
            <Input name="subject" placeholder={translate('change_order_properties.subject_placeholder')} required />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <TextArea name="description" placeholder={translate('change_order_properties.description_placeholder')} required rows={10} />
          </div>
          <div className="col-sm-3 text-5 additional-info-color">
            {translate('change_order_properties.description_help')}
          </div>
        </div>
        <h2>{translate('change_order_properties.start_end_title')}</h2>
        <div className="row">
          <div className="col-sm-3 col-xs-6">
            <DayPickerInput
                    dayPickerProps={{
                      locale: currentLanguage,
                      localeUtils: MomentLocaleUtils,
                    }}
                    formatDate={this.formatDate}
                    inputProps={{
                      name: 'startDate',
                    }}
                    parseDate={this.parseDate}
                    placeholder={translate('change_order_properties.start_end_placeholder')}
                    required />
          </div>
          <div className="col-sm-3 col-xs-6">
            <DayPickerInput
                    dayPickerProps={{
                      locale: currentLanguage,
                      localeUtils: MomentLocaleUtils,
                    }}
                    formatDate={this.formatDate}
                    inputProps={{
                      name: 'endDate',
                    }}
                    onDayChange={this.onStartChanged}
                    parseDate={this.parseDate}
                    placeholder={translate('change_order_properties.start_end_placeholder')}
                    required />
          </div>
          <div className="col-sm-3 text-5 additional-info-color">
            {translate('change_order_properties.start_end_help')}
          </div>
        </div>
      </div>
    );
  }

  renderDestinationSelection() {
    const { translate, destinationList = [] } = this.props;

    const changeOrderDestinationList = [];
    if (destinationList.length !== 0) {
      destinationList.data.map((dat) => changeOrderDestinationList.push(dat));
    }

    return (
      <div>
        <h2>{translate('destination.singular')}</h2>
        <div className="row">
          <div className="col-sm-6">
            <Select name="destinationId"
                    placeholder={translate('destination.singular')}
                    required
                    onChange={this.onDestinationSelected}
                    data={changeOrderDestinationList.map((destination) => ({
                      value: destination.id,
                      text: `${destination.companyName}, ${destination.streetAddress}`,
                    }))} />
          </div>
        </div>
      </div>
    );
  }

  renderServiceSites() {
    const { translate } = this.props;

    const { destinationId } = this.state;
    const { destinationMap: { [destinationId]: { serviceSites } = {} } = {} } = this.props;

    if (destinationId === undefined) {
      return undefined;
    }

    let serviceSitesComponent;

    if (serviceSites && serviceSites.length === 0) {
      serviceSitesComponent = (
        <h4>{translate('destination_no_service_sites')}</h4>
      );
    } else {
      serviceSitesComponent = (
        <ServiceSiteList serviceSites={(serviceSites || []).map((serviceSite) => ({
          ...serviceSite,
          checkbox: {
            name: 'serviceSiteId',
            value: serviceSite.id,
          },
        }))} />
      );
    }

    return (
      <div>
        <h2>{translate('service_site.plural')}</h2>

        <div className="row">
          <div className="col-sm-10">
            {serviceSitesComponent}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="container">
        <form onSubmit={this.onSubmit}>
          {this.renderChangeDetails()}

          {this.renderDestinationSelection()}

          {this.renderServiceSites()}

          <div className="row">
            <div className="col-sm-2">
              <Input type="reset" value={translate('form.reset')} />
            </div>
            <div className="col-sm-2">
              <Input type="submit" value={translate('form.submit')} />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { locale, destination: { destinationList, destinationMap } } = state;

  return {
    translate: getTranslate(locale),
    currentLanguage: getActiveLanguage(locale).code,
    destinationList,
    destinationMap,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setSubNavbar,
  requestDestinationList,
  requestChangeOrder,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeOrder);
